<template>
  <div class="footer">
    <footer class="container">
      <div v-if="showMore">
        <h1>联系我们</h1>
        <ul class="footer-ul">
          <li>
            <h2>市场合作</h2>
            <p>市场合作,资源互换请将信息</p>
            <p>发送至: marketing@freshin.com</p>
          </li>
          <li>
            <h2>品牌合作</h2>
            <p>品牌整体推广、品牌合作、品牌活动</p>
            <p>发送至: branding@freshin.com</p>
          </li>
          <li>
            <h2>媒体合作</h2>
            <p>媒体采访、内容合作等</p>
            <p>请联系: media@freshin.com</p>
          </li>
          <li>
            <h2>手机市场合作等</h2>
            <p>手机市场合作等</p>
            <p>请联系: app@freshin.com</p>
          </li>
          <li>
            <h2>澳大利亚办事处</h2>
            <p>Phone: +61 (0) 450 930 719</p>
            <p>Address：101 shafer road, Blackburn north</p>
            <p>VIC 3130, Australia</p>
          </li>
          <li>
            <h2>中国总部</h2>
            <p>电话: 0571-88668673</p>
            <p>邮箱: info@freshin.com</p>
            <p>地址：中国浙江省杭州市余杭区</p>
            <p>文一西路中国人工智能小镇3号楼303室</p>
          </li>
        </ul>
      </div>

      <h3>
        &copy; 2015-2019 freshin.com freshin.online 版权所有
        <a target="_blank" href="https://beian.miit.gov.cn/"
          >浙ICP备19005668号-1</a
        >
        <!-- <a  href="http://www.beian.miit.gov.cn">浙ICP备19005668号-1</a> -->
      </h3>
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    showMore: {
      default: false
    }
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .footer-ul li {
    width: 33.3% !important;
  }
}
.footer {
  background: rgba(31, 37, 50, 1);
  color: #ffffff;
}
.footer a {
  color: #ffffff;
}
.footer h1 {
  font-size: 1.58rem;
  font-weight: normal;
  padding: 2rem 0;
}
.footer-ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.footer-ul li {
  padding-right: 1rem;
  width: 25%;
  margin-bottom: 2rem;
  /* padding-right: 1rem; */
}
.footer-ul li:last-child {
  flex: 1;
  /* justify-self: flex-start; */
}
.footer-ul h2 {
  font-size: 1.25rem;
  font-weight: normal;
  margin-bottom: 1rem;
}
.footer-ul p {
  word-break: break-word;
  line-height: 2;
  font-size: 0.88rem;
  font-weight: 300;
}
.footer h3 {
  padding-top: 1rem;
  padding-bottom: 1rem;
  text-align: center;
  font-size: 0.75rem;
  font-weight: 200;
}
</style>



// WEBPACK FOOTER //
// footers.vue?2511fb68